<template>
  <div class="detail-wrapper animated">
    <b-row>
      <b-col cols="12" :xl="slaveList.length !== 0 && activeSlave && !noSplitDetailCard ? 5 : 12">
        <slot v-if="isBodySlot" name="detail-body" />
        <b-card v-else class="py-5 rounded-xl mb-5 px-0 animated" no-body>
          <b-card-title 
            class="border-bottom border-2 pb-3 mb-2 mx-0 px-5 d-flex align-items-center justify-content-between flex-wrap"
          >
            <span class="card-label font-weight-bold text-dark">
              <i class="ri-information-2-line font-size-h3 mr-1 text-primary font-weight-normal"></i>
              {{ $t("global.detail") }} {{ title }} 
            </span>
            <!-- <span class="text-muted mt-3 font-weight-bold font-size-sm">More than 400+ new members</span> -->
            <div class="card-toolbar ml-auto">
              <a
                v-if="!$store.state.unknownRoute"
                @click="emitEvent('back')"
                class="btn btn-outline-primary btn-icon btn-circle btn-sm"
                v-b-tooltip.top="$t('global.go_back')"
              >
                <i class="ri-arrow-go-back-line p-0"></i>
              </a>
              <a
                v-if="permission && $_sys.isAllowed(permission.update)"
                @click="emitEvent('update', realData)"
                class="btn btn-light-warning btn-icon btn-circle btn-sm"
                v-b-tooltip.top="$t('global.update')"
              >
                <i class="ri-edit-box-line p-0"></i>
              </a>
              <a
                v-if="slaveList.length !== 0 && activeSlave && !noSplitDetailCard"
                v-b-toggle="`detailCollapse${title.replace(/\s/g, '')}`"
                :class="`btn btn-${collapseDetail ? 'light' : 'outline'}-primary btn-icon btn-circle btn-sm
                  toggle-btn-collapse
                  ${collapseDetail ? 'toggle-active' : ''}
                `"
                v-b-tooltip.top="`Toggle view detail card`"
              >
                <i class="ri-arrow-down-s-line p-0"></i>
              </a>
              <!-- <a @click="emitEvent('print')" class="btn btn-outline-primary btn-icon btn-circle" v-b-tooltip.top="$t('global.export')">
                <i class="ri-printer-line p-0"></i>
              </a>
              <div class="v-separator mx-3"></div> -->
            </div>
          </b-card-title>
          <b-collapse visible class="px-5 py-0 pt-2" 
            :id="`detailCollapse${title.replace(/\s/g, '')}`"
            v-model="collapseDetail"
          >
            <slot name="detail-card-body" v-bind:rowData="realData">
              <div class="table-responsive animated">
                <div v-if="isLoading" style="position: relative;min-height: 200px;">
                  <div class="card-img-overlay d-flex align-items-center justify-content-center" style="background-color: #ffffffaa;z-index: 2;">
                      <lottie-loading></lottie-loading>
                      <!-- <div class="mr-2 text-muted">{{ $t('global.loading') }} ...</div>
                      <div class="spinner spinner-primary mr-10"></div> -->
                  </div>
                </div>
                <table v-if="!isLoading" class="table table-detail">
                  <tbody>
                    <tr
                      v-for="(h, j) in visibleFields"
                      :key="j"
                    >
                      <td class="nowrap-table">
                        <div class="d-flex align-items-center">
                          <i v-if="h.icon" :class="`${h.icon} mr-1`"></i>
                          {{ h.label }}
                        </div>
                      </td>
                      <td class="nowrap-table align-middle">&emsp;:&nbsp;</td>
                      <td class="align-middle">
                        <field-renderer 
                          :field="h" 
                          :data="mainData[h.id]" 
                          @zoom="emitEvent('zoom', $event)"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </slot>
          </b-collapse>
        </b-card>
        <slot name="detail-footer" v-bind:rowData="realData"></slot>
      </b-col>
  <b-col cols="12" :xl="slaveList.length !== 0 && activeSlave && !noSplitDetailCard ? 7 : 12" :style="{ marginTop: noSplitDetailCard ? '0' : '-17px' }">
        <div v-if="slaveList.length !== 0 && activeSlave">
          <b-nav v-if="slaveList.length > 1" pills class="nav-light-primary mt-5">
            <b-nav-item
              v-for="(s, i) in slaveList"
              :key="i"
              :active="activeSlave.name === s.name"
              @click="setActiveSlave(s)"
              class="font-weight-bold"
            >
              {{ s.name }}</b-nav-item
            >
          </b-nav>
          <div v-if="activeSlave">
            <component :is="componentLoader"></component>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "main-detail",
  props: {
    API: { type: String, required: true },
    fields: { type: Array, required: true },
    export: { type: Boolean, required: false },
    title: { type: String, required: true },
    permission: { type: Object, required: true },
    slave: { type: Array, required: false },
    id: { type: Number, required: true },
    isBodySlot: { required: true },
    isCustomAPI: {
      type: Boolean,
      required: false,
      default() {
        return false;
      }
    },
    noSplitDetailCard: {
      default: false
    }
  },
  data() {
    return {
      mainData: null,
      slaveList: [],
      activeSlave: null,
      isLoading: false,
      realData: null,
      collapseDetail: true,
    };
  },
  watch: {
    id: {
      deep: false,
      immediate: true,
      handler(to, from) {
        if (!this.isBodySlot) this.getData(to);
        else if (this.slave && this.slave.length > 0) this.loadSlave();
      }
    }
  },
  computed: {
    componentLoader() {
      if (!this.activeSlave) return null;
      const loader = this.activeSlave.slave;
      return () => import(`@/modules/${loader}.vue`);
    },
    
    visibleFields() {
      return this.fields.filter(x => 
        (x.show === true || (x.methods && x.methods.detail !== false)) && 
        (!x.permission || this.$_sys.isAllowed(x.permission))
      );
    }
  },
  
  components: {
    FieldRenderer: {
      name: 'FieldRenderer',
      props: ['field', 'data'],
      methods: {
        classReader(value, classes) {
          if (classes instanceof Object) {
            if (value instanceof Array) {
              return value.map(val => classes[val]).join(' ');
            }
            return classes[value];
          }
          return classes;
        },
        
        renderArrayData(data, field) {
          if (!Array.isArray(data)) return data;
          return data.map(item => {
            if (item && typeof item === 'object' && item.data instanceof Array) {
              return this.renderSingleArrayItem(item, field);
            }
            return this.renderSingleItem(item, field);
          });
        },
        
        renderSingleArrayItem(item, field) {
          const { type, data } = item;
          return data.map((d, index) => ({
            type,
            value: d,
            key: `${field.id}-${type}-${index}`,
            classes: this.classReader(d, field.class)
          }));
        },
        
        renderSingleItem(item, field) {
          return {
            type: item.type || 'text',
            value: item.data || item,
            key: `${field.id}-single`,
            classes: this.classReader(item.data || item, field.class)
          };
        },
        
        getFileUrl(data) {
          if (data && data.file && data.file.url) return data.file.url;
          if (data && data.url) return data.url;
          return '';
        }
      },
      
      template: `
        <div>
          <!-- Array data handling -->
          <template v-if="data instanceof Array">
            <template v-for="(item, index) in data" :key="index">
              <field-renderer 
                :field="field" 
                :data="item" 
                @zoom="$emit('zoom', $event)"
              />
            </template>
          </template>
          
          <!-- Object data handling -->
          <template v-else-if="data && typeof data === 'object'">
            <!-- Array data within object -->
            <template v-if="data.data instanceof Array">
              <template v-for="(d, k) in data.data" :key="k">
                <!-- Text type -->
                <span v-if="data.type === 'text'" 
                      :class="classReader(d, field.class)">
                  {{ d | parse(field.transform) }}{{ k !== data.data.length - 1 ? ', ' : ' ' }}
                </span>
                
                <!-- Button type -->
                <a v-else-if="data.type === 'button'"
                   class="btn btn-sm"
                   :class="classReader(d, field.class) || 'btn-primary'"
                   @click="field.event && field.event.click ? field.event.click() : null">
                  {{ d | parse(field.transform) }}
                </a>
                
                <!-- Link type -->
                <a v-else-if="data.type === 'link'"
                   class="d-block text-primary"
                   :class="classReader(d, field.class)"
                   :href="d" target="_blank">
                  {{ d | parse(field.transform) }}
                </a>
                
                <!-- File type -->
                <img v-else-if="data.type === 'file'"
                     class="img-table"
                     :class="classReader(d, field.class)"
                     v-img-fb="d"
                     :alt="field.id"
                     @click="$emit('zoom', d)" />
                
                <!-- File multiple images -->
                <img v-else-if="data.type === 'file-multiple-img'"
                     class="img-table"
                     :class="classReader(d, field.class)"
                     v-img-fb="getFileUrl(d)"
                     :alt="field.id"
                     @click="$emit('zoom', getFileUrl(d))" />
                
                <!-- File multiple videos -->
                <video v-else-if="data.type === 'file-multiple-video'"
                       class="img-table"
                       :class="classReader(d, field.class)"
                       controls :src="d" :alt="field.id" />
                
                <!-- Unknown type -->
                <span v-else>
                  {{ $t("error.view_type") }} ({{ data.type }})
                </span>
              </template>
            </template>
            
            <!-- Single object data -->
            <template v-else>
              <!-- Text -->
              <span v-if="data.type === 'text'"
                    :class="classReader(data.data, field.class)">
                {{ data.data | parse(field.transform) }}
              </span>
              
              <!-- Color -->
              <div v-else-if="data.type === 'color'" class="d-flex">
                <div :style="{'background-color': data.data, 'height': '70px', 'width': '70px'}"
                     class="rounded"></div>
                <div class="ml-2">
                  <p class="mb-2">Hex: {{ data.data }}</p>
                  <p>RGB: {{ $_sys.hexToRgb(data.data) }}</p>
                </div>
              </div>
              
              <!-- TinyMCE -->
              <div v-else-if="data.type === 'tinymce'"
                   v-html="data.data"
                   :class="classReader(data.data, field.class)"></div>
              
              <!-- Button -->
              <a v-else-if="data.type === 'button'"
                 class="btn btn-sm"
                 :class="classReader(data.data, field.class) || 'btn-primary'"
                 @click="field.event && field.event.click ? field.event.click() : null">
                {{ data.data | parse(field.transform) }}
              </a>
              
              <!-- Link -->
              <a v-else-if="data.type === 'link'"
                 class="text-primary"
                 :class="classReader(data.data, field.class)"
                 :href="data.data" target="_blank">
                {{ data.data | parse(field.transform) }}
              </a>
              
              <!-- File -->
              <img v-else-if="data.type === 'file'"
                   class="img-table"
                   :class="classReader(data.data, field.class)"
                   v-img-fb="data.data"
                   :alt="field.id"
                   @click="$emit('zoom', data.data)" />
              
              <!-- Unknown -->
              <span v-else>
                {{ $t("error.view_type") }} ({{ data.type }})
              </span>
            </template>
          </template>
          
          <!-- Simple data -->
          <span v-else>{{ data }}</span>
        </div>
      `
    }
  },
  beforeDestroy() {
    if (!this.slave) this.$store.commit("set", ["activeSlave", {}, true]);
  },
  methods: {
    emitEvent(e, data = null) {
      // console.log("e", e);
      // console.log("data", data);
      const value = data || true;
      this.$emit(e, value);
    },
    async getData(id) {
      this.isLoading = true;
      this.mainData = null;
      
      try {
        const response = await this.fetchData(id);
        this.realData = response.data;
        
        if (this.slave.length) {
          await this.loadSlave(response.data);
        }
        
        this.mainData = await this.buildData(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
        this.$_alert.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    
    async fetchData(id) {
      if (this.isCustomAPI) {
        return this.$_api.get(this.API, { id });
      }
      
      const [endpoint, query] = this.API.split('?');
      return this.$_api.single(endpoint, query, id);
    },
    async buildData(data) {
      const newData = {};
      
      this.fields.forEach(field => {
        const fieldData = this.getFieldData(field, data);
        if (fieldData !== null) {
          newData[field.id] = fieldData;
        }
      });
      
      return newData;
    },
    
    getFieldData(field, data) {
      if (field.view_data instanceof Array) {
        return field.view_data.map((viewData, index) => ({
          type: (field.type && field.type[index]) || 'text',
          data: this.renderVal(data, viewData),
          icon: field.icon
        }));
      }
      
      return {
        type: this.getFieldType(field),
        data: this.renderVal(data, field.view_data || field.data || field.id),
        icon: field.icon
      };
    },
    
    getFieldType(field) {
      if (field.methods && field.methods.detail && field.methods.detail.type) return field.methods.detail.type;
      if (field.type) return field.type;
      return 'text';
    },
    
    renderVal(source, prop) {
      if (!prop || !source) return null;
      
      if (prop.includes('.')) {
        return this.renderNestedProp(source, prop);
      }
      
      if (this.isFileField(prop)) {
        return this.renderFileField(source, prop);
      }
      
      return source[prop];
    },
    
    renderNestedProp(source, prop) {
      const parts = prop.split('.');
      let current = source;
      
      for (const part of parts) {
        if (current && current[part]) {
          current = current[part];
        } else if (Array.isArray(current)) {
          current = current.map(item => (item && item[part]) ? item[part] : null).filter(Boolean);
        } else {
          return null;
        }
      }
      
      return current;
    },
    
    isFileField(prop) {
      return prop.includes('file') || prop.includes('detail_file');
    },
    
    renderFileField(source, prop) {
      if (!source[prop]) return [];
      
      if (!Array.isArray(source[prop])) {
        return source[prop].url ? [source[prop].url] : [];
      }
      
      return source[prop].map(file => {
        // Handle different file structures
        if (file && file.file && file.file.url) {
          return { file: file.file, url: file.file.url };
        }
        
        const fieldName = `file_${prop.replace('detail_', '')}`;
        if (file && file[fieldName] && file[fieldName].url) {
          return { file: file[fieldName], url: file[fieldName].url };
        }
        
        if (file && file.url) {
          return { file: file, url: file.url };
        }
        
        return null;
      }).filter(Boolean);
    },
    classReader(value, classes) {
      if (!classes || typeof classes !== 'object') return classes;
      
      if (Array.isArray(value)) {
        return value.map(val => classes[val]).filter(Boolean).join(' ');
      }
      
      return classes[value];
    },
    
    async loadSlave(data) {
      if (!this.slave || !this.slave.length) return;
      
      const slavePromises = this.slave.map(async (slaveConfig) => {
        const isAllowed = slaveConfig.permission 
          ? this.$_sys.isAllowed(slaveConfig.permission)
          : await this.checkSlavePermission(slaveConfig.module);
          
        if (!isAllowed) return null;
        
        return {
          name: slaveConfig.name,
          master: this.title,
          slave: slaveConfig.module,
          param: slaveConfig.as_param,
          key: (data && data[slaveConfig.key_field]) || this.id,
          rules: slaveConfig.overwrite
        };
      });
      
      const slaves = (await Promise.all(slavePromises)).filter(Boolean);
      
      // Add unique slaves only
      slaves.forEach(slave => {
        const exists = this.slaveList.find(existing => existing.name === slave.name);
        if (!exists) {
          this.slaveList.push(slave);
        }
      });
      
      if (this.slaveList.length && !this.activeSlave) {
        this.setActiveSlave(this.slaveList[0]);
      }
    },
    setActiveSlave(data) {
      this.activeSlave = Object.assign({}, this.activeSlave, data);
      this.$store.commit("set", ["activeSlave", data, true]);
    },
    async checkSlavePermission(path) {
      const component = await import(`@/modules/${path}.vue`);
      const compData = component.default.data();
      return this.$_sys.isAllowed(compData.config.permission.read);
    }
  }
};
</script>

<style scoped>
.v-separator {
  border-right: 2px solid #e4e6ef;
  height: 100%;
}

.table-detail tr:first-child td {
  border-top: none !important;
}

.color-inherit {
  color: inherit;
}

.toggle-btn-collapse {
  transition: all 0.3s ease-in-out!important;
  transform: rotate(0deg);
}
.toggle-btn-collapse.toggle-active {
  transform: rotate(180deg)!important;
}
</style>

<style>
.img-table {
  height: 150px !important;
  width: 150px !important;
  max-width: 150px !important;
  border-radius: 8px !important;
  object-fit: cover !important;
  cursor: pointer !important;
  margin-right: 1rem !important;
  margin-bottom: 1rem !important; 
}
</style>



// WEBPACK FOOTER //
// src/base/main-detail.vue